/**
 * Vue Filter - Time Range
 */

/**
 * Convert two numbers to range format.
 *
 * @param {number} min Number value
 * @param {number} max Number value
 * @param {convert} string Conversion type
 * @param {boolean} suffix Use prefix
 */
import pluralize from './pluralize'

export default function timeRange(min = 0, max = 0, conversion, suffix, withLabel) {
// console.log('range', {min, max, conversion, suffix, withLabel })
	suffix = suffix || ' Month'
	if (String(min).match(/life/i)) return `Life`
	if (String(min).match(/death/i)) return `Death Penalty`
	if (String(min).match(/any/i)) return `Any number of years`

	if (max == 1800 || String(max).match(/life/i)) max = `Life`
	if (min == 1800) min = `Life`
	if (!max || max == 10000 || String(max).match(/any/i)) max = `Any number of years`
console.log({ min, max, conversion, suffix, withLabel, })
	switch(conversion) {
		case 'years':
			if (Number(min) > 11) {
				// min = Number(min) / 12
			}
			if (Number(max) > 11) {
				max = Number(max) / 12
			}
			break
	}

	if (withLabel) {
		if (!min || Number(min == 0)) {
			min = null
		} else if (!isNaN(Number(min))) {
			if (min < 12 ) {
				min = `${pluralize(min,'month')} min.`
			} else {
				if (conversion == 'years') {
					min = Number(min) / 12
				}
				min = `${pluralize(min,suffix)} min.`
			}
		} else {
			min = `${min} min.`
		}

		if (!max || Number(max) == 0) {
			max = null
		} else if (!isNaN(Number(max))) {
			max = `${pluralize(max,suffix)} max.`
		} else {
			max = `${max} max.`
		}
	} else {
		if (!isNaN(Number(max))) {
			max = `${pluralize(max,suffix)}`
		} else {
			if (!isNaN(Number(min))) {
				min = `${pluralize(min,suffix)}`
			}
		}

		if (!isNaN(Number(min))) {
			if (min < 12) {
				min = `${min} Months`
			} else {
				if (conversion == 'years') {
					min = min / 12
				}
				min = `${min}`
			}
		}
	}

// console.log('range.after', { min, max, conversion, suffix, })

	return [min, max].filter(n => n).join(` - `)
}
